import { DataResolver } from './types/DataResolver'
import Task from '@vue-storefront/core/lib/sync/types/Task'
import CartItem from '@vue-storefront/core/modules/cart/types/CartItem'
import {
  restApiCreateCart,
  restApiGetTotals,
  restApiGetCartItems,
  restApiGetPaymentMethods,
  restApiPostShippingInformation,
  restApiEstimateShippingMethods,
  restApiUpdateCartItem,
  restApiDeleteCartItem,
  restApiApplyCoupon,
  restApiRemoveCoupon
} from './restApiCart'

const setShippingInfo = async (addressInformation: any): Promise<Task> =>
  restApiPostShippingInformation({ addressInformation })

const getTotals = async (): Promise<Task> =>
  restApiGetTotals()

const getCartToken = async (guestCart = false, _forceClientState = false): Promise<Task> =>
  restApiCreateCart(guestCart)

const updateItem = async (cartServerToken: string, cartItem: CartItem): Promise<Task> =>
  restApiUpdateCartItem(cartServerToken, cartItem)

const deleteItem = async (cartServerToken: string, cartItem: CartItem): Promise<Task> =>
  restApiDeleteCartItem(cartServerToken, cartItem)

const getPaymentMethods = async (): Promise<Task> =>
  restApiGetPaymentMethods()

const getShippingMethods = async (address: any): Promise<Task> =>
  restApiEstimateShippingMethods(address)

const getItems = async (): Promise<Task> =>
  restApiGetCartItems()

const applyCoupon = async (couponCode: string): Promise<Task> =>
  restApiApplyCoupon(couponCode)

const removeCoupon = async (): Promise<Task> =>
  restApiRemoveCoupon()

export const CartService: DataResolver.CartService = {
  setShippingInfo,
  getTotals,
  getCartToken,
  updateItem,
  deleteItem,
  getPaymentMethods,
  getShippingMethods,
  getItems,
  applyCoupon,
  removeCoupon
}
